import { useParams } from "react-router-dom";
import Product6501 from "./engine-oil/synthetic/6501";
import Product6702 from "./engine-oil/synthetic/6702";
import Product6711 from "./engine-oil/synthetic/6711";
import Product6724 from "./engine-oil/synthetic/6724";
import Product6726 from "./engine-oil/synthetic/6726";
import Product3002 from "./service-fluids/service/3002"
import Product4211 from "./service-fluids/service/4211"
import Product4212 from "./service-fluids/service/4212"
import Product4213 from "./service-fluids/service/4213"
import Product6707 from "./engine-oil/synthetic/6707";
import Product6201 from "./motor-oil/motorcycle-oils/6201";
import Product6208 from "./motor-oil/motorcycle-oils/6208";
import Product8605 from "./gear-oils/gear-oil/8605"
import Product8614 from "./gear-oils/gear-oil/8614"
import Product8615 from "./gear-oils/gear-oil/8615"
import Product8616 from "./gear-oils/gear-oil/8616"
import Product8701 from "./gear-oils/gear-oil/8701"
import Product8702 from "./gear-oils/gear-oil/8702"
import Product8710 from "./gear-oils/gear-oil/8710"

// future products import here

function AllProduct() {
  const { id } = useParams();

  switch (id) {
    case "6501":
      return <Product6501 />;

    // future
    case "6702":
      return <Product6702 />;
    case "6711":
      return <Product6711 />;
    case "6724":
      return <Product6724 />;
    case "6726":
      return <Product6726 />;
     
    case "6201":
      return <Product6201 />; 
    case "6208":
      return <Product6208 />;
    case "3002":
       return <Product3002 />;
    case "6707":
      return <Product6707/>;
    case "8605":
      return <Product8605/>;
    case "8614":
      return <Product8614/>;
    case "8615":
      return <Product8615/>;
    case "8616":
      return <Product8616/>
    case "8701":
      return <Product8701/>
    case "8702":
      return <Product8702/>
    case "8710":
      return <Product8710/>
    case "4211":
      return <Product4211/>
    case "4212":
      return <Product4212/>
    case "4213":
      return <Product4213/>

    default:
      return <h2>Product Not Found</h2>;
  }
}

export default AllProduct;